import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { PaymentElementTypes } from "../payments/payment.model";
import { UsersElementTypes } from "../users/user.model";
import { ExerciseAffectationDTO, ExerciseBlockDTO, ExerciseDTO } from "./exercise.dto";
import { Program, ProgramAffectationDTO } from "./program.dto";
import { ProgramSession } from "./programSession.dto";
import { RatingDTO } from "./rating.dto";
import { Session } from "./session.dto";

export type ProgramElementTypes = {
    "exercises": ExerciseDTO,
    "sessions": Session,
    "exercise_blocks": ExerciseBlockDTO,
    "exercise_affectations": ExerciseAffectationDTO,
    "ratings": RatingDTO,
    "programs": Program,
    "program_affectations": ProgramAffectationDTO,
    "program_sessions": ProgramSession
}

type AffectationType = {
    "exercise_session": ExerciseAffectationDTO
}

export type ProgramElementTypeNames = keyof ProgramElementTypes;
export const ProgramElementTypeNames: ProgramElementTypeNames[] = keys<ProgramElementTypes>();

export const programTypeInfos: ETTypeInfos<ProgramElementTypes, ProgramElementTypes & UsersElementTypes & AffectationType & PaymentElementTypes> = {
    "programs": {
        keys: keys<Program>(),
        typeInfos: typeInfos<Program>(),
        foreignKeys: {
            authorId: "user_profiles",
            ownerCompanyId: "companies",
            fromId: "programs"
        },
        archivedField: "archived"
    },
    "program_affectations": {
        keys: keys<ProgramAffectationDTO>(),
        typeInfos: typeInfos<ProgramAffectationDTO>(),
        foreignKeys: {
            programId: "programs",
            applicantId: "user_profiles",
            professionalId: "user_profiles",
            subscriptionId: "subscriptions"
        }
    },
    "exercises": {
        keys: keys<ExerciseDTO>(),
        typeInfos: typeInfos<ExerciseDTO>(),
        foreignKeys: {
            ownerCompanyId: "companies",
            authorId: "user_profiles"
        },
        archivedField: "archived"
    },
    "sessions": {
        keys: keys<Session>(),
        typeInfos: typeInfos<Session>(),
        foreignKeys: {
            ownerCompanyId: "user_profiles",
            fromId: "sessions"
        },
        archivedField: "archived"
    },
    "program_sessions": {
        keys: keys<ProgramSession>(),
        typeInfos: typeInfos<ProgramSession>(),
        foreignKeys: {
            programId: "programs",
            sessionId: "sessions"
        }
    }, "exercise_blocks": {
        keys: keys<ExerciseBlockDTO>(),
        typeInfos: typeInfos<ExerciseBlockDTO>(),
        foreignKeys: {
            sessionId: "sessions"
        }
    },
    "exercise_affectations": {
        keys: keys<ExerciseAffectationDTO>(),
        typeInfos: typeInfos<ExerciseAffectationDTO>(),
        foreignKeys: {
            blockId: "exercise_blocks",
            exerciseId: "exercises"
        }
    },
    "ratings": {
        keys: keys<RatingDTO>(),
        typeInfos: typeInfos<RatingDTO>(),
        foreignKeys: {
            programSessionId: "program_sessions"
        }
    }
};